<template>
  <div>
    <h1>请先完成实名认证</h1>
    <div
      style="
        display: flex;
        align-items: center;
        margin-top: 20px;
        font-size: 20px;
      "
    >
      <div style="width: 110px">姓名：</div>
      <Input
        v-model="auditUsername"
        placeholder="请输入姓名"
        style="width: 300px"
      />
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        margin-top: 20px;
        font-size: 20px;
      "
    >
      <div style="width: 110px">身份证号：</div>
      <Input
        v-model="auditIdNo"
        placeholder="请输入身份证号"
        style="width: 300px"
      />
    </div>
    <Button style="margin-top: 20px" @click="authentication()" type="primary"
      >提交</Button
    >
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "userinfo",
  data() {
    return { auditIdNo: "", auditUsername: "" };
  },
  methods: {
    authentication() {
      if (this.auditUsername) {
        if (this.auditIdNo) {
          api
            .UserRealm({
              idNo: this.auditIdNo,
              username: this.auditUsername,
            })
            .then((res) => {
              alert(res.body.message);
            });
        } else {
          alert("请输入身份证号");
        }
      } else {
        alert("请输入姓名");
      }
    },
  },
};
</script>

<style scoped>
</style>
